import * as Icons from 'lucide-react';

export interface IconProps {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export function Icon({ name, size = 20, strokeWidth = 1.8, className }: IconProps): JSX.Element | null {
  // Support both PascalCase ("ShieldCheck") and legacy camelCase ("shieldCheck")
  const key = name.charAt(0).toUpperCase() + name.slice(1);
  const Comp = (Icons as Record<string, any>)[key];
  if (!Comp) return null;
  return <Comp size={size} strokeWidth={strokeWidth} className={className} aria-hidden />;
}
